<script>
    import "./sidebar.css";
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    export let sidebarStep;

</script>
<div class="pl-sidebar">
    <ul class="list-none flex column-direction flex-wrap">
        <li><button class="pl-nav {sidebarStep === 1 ? 'active' : sidebarStep > 1 ? 'white' : 'disable-click' }" on:click={() => dispatch("next", 1)}>Project Details</button></li>
        <li><button class="pl-nav {sidebarStep === 2 ? 'active' : sidebarStep > 2 ? 'white' : 'disable-click'}" on:click={() => dispatch("next", 2)}>Token Details</button></li>
        <li><button class="pl-nav {sidebarStep === 3 ? 'active' : sidebarStep > 3 ? 'white' : 'disable-click'}" on:click={() => dispatch("next", 3)}>Sale Config</button></li>
    </ul>
</div>